<template>
    <div class="file-card-wrapper">
        <b-card id="lib-file"  @click="selectFile($event, item)" @contextmenu.prevent="showContextMenu" v-bind:class="{ selected: isSelected(item.key), private: isPrivate, 'context-menu-active': contextMenu.visible }">
            <template v-if="itemsSelected.length == 1">
                <b-button type="submit" variant="success" @click="editFile" v-if="itemsSelected[0].key == item.key" class="edit-button"><i class="fa fa-pencil"></i></b-button>
            </template>

             <b-link @click.stop="openPreview" class="view-link"><i class="fa fa-eye"></i></b-link>
             <b-link @click="showShareModal" class="is-private" v-if="isPrivate"><i class="fa fa-lock" ></i></b-link>

            <div class="image_wrapper" @click="preview">
                <template v-if="showPreview">
                    <b-spinner v-if="blob == null" />
                    <img :src="`data:;base64,${blob}`" v-else/>
                </template>

                <span :class="`fiv-cla fiv-icon-${getFileExtension(item.name)}`" v-else></span>

            </div>
            <p>{{ formatName(item.name, 15) }}</p>
            <p><small>{{ item.ext }}</small></p>
        </b-card>
        
        <FileContextMenu
            :visible="contextMenu.visible"
            :position="contextMenu.position"
            :file="item"
            :isPrivate="isPrivate"
            @action="handleContextAction"
        />

        <PdfToHtmlModal
            :show="pdfConvertModal.show"
            :file="item"
            :currentPath="currentPath"
            @close="pdfConvertModal.show = false"
            @convert="handlePdfToHtmlConvert"
        />

        <TxtToPdfModal
            :show="txtToPdfModal.show"
            :file="item"
            :currentPath="currentPath"
            @close="txtToPdfModal.show = false"
            @convert="handleTxtToPdfConvert"
        />

        <FilePreviewModal
            :show="previewModal.show"
            :file="item"
            @close="previewModal.show = false"
            @download="handlePreviewDownload"
        />

        <HtmlToPdocModal
            :show="htmlToPdocModal.show"
            :file="item"
            @close="htmlToPdocModal.show = false"
            @convert="handleHtmlToPdocConvert"
        />

        <PdfFormFieldsModal
            :show="pdfFormFieldsModal.show"
            :file="item"
            @close="pdfFormFieldsModal.show = false"
        />

        <ImageExifModal
            :show="imageExifModal.show"
            :file="item"
            @close="imageExifModal.show = false"
        />

        <ExtractTextModal
            :show="extractTextModal.show"
            :file="item"
            :currentPath="currentPath"
            @close="extractTextModal.show = false"
            @extract="handleExtractText"
        />

        <main-dialog
            title="Move File" 
            v-model="moveModal.show" 
            @ok="handleMoveFile"
            ok-title="Move"
        >
            <InputField 
                name="new_path" 
                :label="$t('newPath')" 
                v-model="moveModal.newPath"
                :rules="{required:true}"
                placeholder="e.g., /new/folder/path"
                description="Enter the new path for the file (without filename)"
            />
            
            <b-alert variant="info" show class="mt-3">
                <small>
                    <strong>Current path:</strong> {{ file.key }}<br>
                    <strong>File will be moved to:</strong> {{ moveModal.newPath ? moveModal.newPath + '/' + file.name : '...' }}
                </small>
            </b-alert>
        </main-dialog>

        <main-dialog :title="formatName(item.name, 30)" v-model="fileModal.show" :hide-footer="true">
            <InputField name="local_url" :label="this.$t('localUrl')" :value="localUrl"
                :disabled=true
                :rules="{required:true, length: {min: 2}}"
            />

            <InputField name="public_url" :label="this.$t('publicUrl')" :value="item.public_url"
                :disabled=true
                :rules="{required:true, length: {min: 2}}"
                v-if="!isPrivate"
            />

            <InputField name="size" type="text" :label="this.$t('size')" :value="getFileModalSizeAndType()[0]"
                :disabled=true
                :rules="{required:true}"
                :sufix="getFileModalSizeAndType()[1]"
            />

            <InputField name="created_by" type="text" :label="this.$t('createdBy')" :value="item.created_by"
                :disabled=true
                :rules="{required:true}"
            />

            <b-form-group
                :label-cols="12"
                :horizontal="false">

                <template #label>
                    Metadata
                </template>
                
                <b-row v-for="metadata in Object.keys(item.metadata || {})" :key="metadata" class="mt-1">
                    <b-col cols="6">
                        <b-input placeholder="Key" :value="metadata" disabled/>
                    </b-col>

                    <b-col cols="6">
                        <b-input placeholder="Value" :value="item.metadata[metadata]" disabled/>
                    </b-col>
                </b-row>
            </b-form-group>
        </main-dialog>

        <main-dialog title="Share private file" v-model="privateModal.show" v-if="isPrivate" ok-only ok-title="Share" @ok="share" :hide-footer="privateModal.shareURL !== null">
            <SelectField name="roles" :label="this.$t('shareVia')" :description="this.$t('privateMedia')" v-model="privateModal.shareType"
                :items="privateModal.shareTypes"
                :rules="{required:false}"
            />

            <DateTimeField name="valid_until" :label="this.$t('validUntil')" :description="this.$t('shareLink')" v-model="privateModal.validUntil"
                :disablePastDates="true"
                :minuteStep="5"
                :rules="{required:false}"
            />

            <b-form-group
                v-if="privateModal.shareType == 'email'"
                :label="this.$t('emails')"
                label-for="emails"
                :label-cols="2"
                :label-cols-sm="2"
                :description="this.$t('emailsSeparated')"
                :horizontal="false">
                <b-textarea v-model="privateModal.emails" />
            </b-form-group>

            <InputField name="share_url" :label="this.$t('shareUrl')" :value="privateModal.shareURL"
                :disabled="true"
                :rules="{required:true, length: {min: 2}}"
                v-if="privateModal.shareURL !== null && privateModal.shareType == 'link'"
            />
        </main-dialog>
    </div>
</template>

<style scoped lang="scss">
    @import "@/assets/scss/_custom.scss";
    @import "@/assets/scss/style.scss";
    @import "~file-icon-vectors/dist/file-icon-vectors.min.css";
    @import "~file-icon-vectors/dist/file-icon-classic.min.css";

    .file-card-wrapper {
        width: 100%;
        height: 100%;
    }

    .fiv-cla {
        font-size: 100px;
        margin-top: 25px;
    }

    img {
        width: 100%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 0;
    }

    #lib-file .btn-success {
        position: absolute;
        left: 0;
        top: 0;
        border-radius: 0;
        padding: 3px 6px;
    }

    #lib-file .view-link {
        position: absolute;
        left: 0;
        bottom: 0;
        margin: 5px;
        opacity: 0.7;
    }

     #lib-file .is-private {
        position: absolute;
        right: 0;
        bottom: 0;
        margin: 5px;
        opacity: 0.7;
    }

    #lib-file .image_wrapper {
        width: 100%;
        position: relative;
        height: 150px;
        overflow: hidden;
    }

    #lib-file {
        overflow: hidden;
        border: 1px solid $dark-border2;
        background: $dark-background;
        cursor: pointer;
        transition: all 0.2s ease;

        &:hover {
            border-color: $protokol-royal-active;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        }
    }

    #lib-file.private {
        border: 1px solid $warning;
    }

    #lib-file > .card-body {
        padding: 5px;
    }

    #lib-file.selected {
        border: 2px solid #20a8d8 !important;
    }

    #lib-file.context-menu-active {
        border: 2px solid var(--primary-start) !important;
        box-shadow: 0 0 0 2px rgba(108, 99, 255, 0.2);
    }

    #lib-file p {
       display: block;
       margin: 0;
       padding: 5px;
    }

    #lib-file .edit-button {
        z-index: 999;
    }

    #lib-file {
        text-align: center;
    }

    #lib-dir i {
        float: left;
        padding: 0px 15px 0px 0px;
    }

    #lib-dir p {
        padding: 5px 0px 0px 0px;
        margin: 0;
    }
</style>

<script>
import Input from "@/components/form/Input"
import Select from "@/components/form/Select"
import DateTime from "@/components/form/DateTime"
import FileContextMenu from "./FileContextMenu.vue"
import PdfToHtmlModal from "./PdfToHtmlModal.vue"
import TxtToPdfModal from "./TxtToPdfModal.vue"
import FilePreviewModal from "./FilePreviewModal.vue"
import HtmlToPdocModal from "./HtmlToPdocModal.vue"
import PdfFormFieldsModal from "./PdfFormFieldsModal.vue"
import ImageExifModal from "./ImageExifModal.vue"
import ExtractTextModal from "./ExtractTextModal.vue"
import { truncate } from 'lodash'

export default {
    components: {
        InputField: Input,
        SelectField: Select,
        DateTimeField: DateTime,
        FileContextMenu,
        PdfToHtmlModal,
        TxtToPdfModal,
        FilePreviewModal,
        HtmlToPdocModal,
        PdfFormFieldsModal,
        ImageExifModal,
        ExtractTextModal
    },
    props: {
        file: {
            type: Object
        },

        library: {
            type: Object
        },

        itemsSelected: {
            type: Array
        },

        public: {
            type: Boolean
        },
        
        size: {
            type: Number,
            default: 2
        },

        currentPath: {
            type: String,
            default: ''
        }
    },

    data: function() {
        return {
            item: this.file,
            fileModal: {
                show: false,
                title: '',
                data: {}
            },
            blob: null,
            showPreview: false,
            privateModal: {
                show: false,
                shareURL: null,
                shareType: 'link',
                shareTypes: ['link', 'email'],
                validUntil: '',
                emails: ''
            },
            contextMenu: {
                visible: false,
                position: { x: 0, y: 0 }
            },
            pdfConvertModal: {
                show: false
            },
            txtToPdfModal: {
                show: false
            },
            previewModal: {
                show: false
            },
            htmlToPdocModal: {
                show: false
            },
            pdfFormFieldsModal: {
                show: false
            },
            imageExifModal: {
                show: false
            },
            extractTextModal: {
                show: false
            },
            moveModal: {
                show: false,
                newPath: ''
            }
        }
    },

    computed: {
        localUrl() {
            return this.file.local_url
        },

        isPrivate() {
            return !this.public
        }
    },

    methods: {
        selectFile(event, item) {
            this.$emit('selectFile', event, item)
        },

        getFileModalSizeAndType() {
            let size = this.item.size / 1024
            if (size < 1024) {
                return [size.toFixed(2), "KB"]
            }

            size = size / 1024
            if (size < 1024) {
                return [size.toFixed(2), "MB"]
            }

            return [size.toFixed(2), "B"];
        },

        preview() {
            if (!this.isFileImage(this.file)) return
            this.showPreview = true;
            this.$mediaHttp.get(this.file.local_url, {responseType: 'arraybuffer' }).then(resp => {
                const base64 = btoa(
                    new Uint8Array(resp.data).reduce(
                        (data, byte) => data + String.fromCharCode(byte),
                        '',
                    ),
                    );

                this.blob = base64
            }).catch(error => {
                //
                console.log(error)
            })
        },

        saveEditFile() {
            this.$mediaHttp.post("/v1/media/edit/" + this.fileModal.data.uuid, this.fileModal.data).then(resp => {
                //console.log(resp)
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$mainDialog.msgBoxOk(error.response.message)
            })
        },

        share(e) {
            if (this.privateModal.shareType == 'link')
                e.preventDefault();

            this.$mediaHttp.post("/v1/media/library/" + this.library.uuid + "/share", {key: this.file.key, date: this.privateModal.validUntil}).then(resp => {
                //console.log(resp)
                this.privateModal.shareURL = resp.data
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$mainDialog.msgBoxOk(error.response.message)
            })
        },

         editFile() {
            this.fileModal.show = true
        },

        isSelected(key) {
            return this.itemsSelected.find(i => {
                return i.key == key
            })
        },

        getFileExtension(name) {
            let l = name.split(".")

            return l[l.length - 1]
        },

        isFileImage(item) {
            let ext = this.getFileExtension(item.name)

            return ext == 'jpg' || ext == 'jpeg' || ext == 'png' || ext == 'webp' || ext == 'gif'
        },

        showShareModal() {
            this.privateModal.show = true
            this.privateModal.shareURL = null
            this.privateModal.validUntil = null
        },

        formatName(name, p) {
            return truncate(name, {
                omission: '...',
                length: p || 10
            })
        },

        showContextMenu(event) {
            event.preventDefault();
            
            // Emit event to parent to close other context menus
            this.$emit('showContextMenu', this.file.key);
            
            this.contextMenu.position = {
                x: event.clientX,
                y: event.clientY
            };
            this.contextMenu.visible = true;
            
            // Close menu when clicking anywhere else
            const closeMenu = () => {
                this.contextMenu.visible = false;
                document.removeEventListener('click', closeMenu);
            };
            
            setTimeout(() => {
                document.addEventListener('click', closeMenu);
            }, 0);
        },

        closeContextMenu() {
            this.contextMenu.visible = false;
        },

        handleContextAction(action) {
            this.contextMenu.visible = false;
            
            switch(action) {
                case 'view':
                    this.openPreview();
                    break;
                case 'download':
                    this.downloadFile();
                    break;
                case 'share':
                    this.showShareModal();
                    break;
                case 'copyUrl':
                    this.copyUrlToClipboard();
                    break;
                case 'info':
                    this.fileModal.show = true;
                    break;
                case 'delete':
                    this.deleteFile();
                    break;
                // PDF tools
                case 'pdfToHtml':
                    this.convertPdfToHtml();
                    break;
                case 'pdfFormFields':
                    this.showPdfFormFields();
                    break;
                // Text tools
                case 'txtToPdf':
                    this.txtToPdfModal.show = true;
                    break;
                // HTML tools
                case 'htmlToPdoc':
                    this.convertHtmlToPdoc();
                    break;
                case 'editHtmlWysiwyg':
                    this.openHtmlWysiwygEditor();
                    break;
                case 'editMdFile':
                    this.openMdFileEditor();
                    break;
                case 'imageExif':
                    this.showImageExif();
                    break;
                case 'extractText':
                    this.extractTextModal.show = true;
                    break;
                case 'move':
                    this.showMoveModal();
                    break;
            }
        },

        convertPdfToHtml() {
            // Show modal for conversion options
            this.pdfConvertModal.show = true;
        },

        showPdfFormFields() {
            // Show modal for PDF form fields
            this.pdfFormFieldsModal.show = true;
        },

        showImageExif() {
            // Show modal for image EXIF data
            this.imageExifModal.show = true;
        },

        openPreview() {
            const extension = this.getFileExtension(this.file.name).toLowerCase();
            const previewableTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'pdf', 'html', 'htm', 'txt', 'log', 'csv', 'md'];
            
            if (previewableTypes.includes(extension)) {
                this.previewModal.show = true;
            } else {
                // For non-previewable files, open in new tab
                window.open(this.localUrl, '_blank');
            }
        },

        handlePreviewDownload(file) {
            this.downloadFile();
        },

        convertHtmlToPdoc() {
            // Show modal for conversion options
            this.htmlToPdocModal.show = true;
        },

        openHtmlWysiwygEditor() {
            // Navigate to the WYSIWYG editor route
            this.$router.push({
                name: 'HtmlWysiwygEditor',
                params: {
                    integration: 'protokol-media',
                    fileKey: this.file.key
                },
                query: {
                    name: this.file.name,
                    lib: this.library.uuid,
                    path: this.currentPath
                }
            });
        },

        openMdFileEditor() {
            this.$router.push({
                name: 'MdFileEditor',
                params: {
                    integration: 'protokol-media',
                    fileKey: this.file.key
                },
                query: {
                    name: this.file.name,
                    lib: this.library.uuid,
                    path: this.currentPath
                }
            });
        },

        handleHtmlToPdocConvert(options) {
            const popup = this.$loadingPopup(this.$t('convertingHtmlToPdoc'));
            
            // First, fetch the HTML content from the media library
            this.$mediaHttp.get(`/v3/dms/media/get/${this.file.key}`, {
                responseType: 'text'
            }).then(resp => {
                const htmlContent = resp.data;
                
                // Now create the PDOC document with the HTML content
                return this.$store.dispatch('documents/createDocument', {
                    path: options.path,
                    variant: options.variant,
                    content: htmlContent
                });
            }).then(resp => {
                this.$bvToast.toast(this.$t('pdocCreatedSuccessfully'), {
                    title: this.$t('success'),
                    variant: 'success'
                });
                
                // Emit event to parent to refresh the file list if needed
                this.$emit('fileConverted', resp);
            }).catch(error => {
                console.error('HTML to PDOC conversion error:', error);
                const message = error.response && error.response.data && error.response.data.message 
                    ? error.response.data.message 
                    : this.$t('conversionFailed');
                    
                this.$bvToast.toast(message, {
                    title: this.$t('error'),
                    variant: 'danger'
                });
            }).finally(() => {
                popup.hide();
            });
        },

        handlePdfToHtmlConvert(options) {
            const popup = this.$loadingPopup(this.$t('convertingPdfToHtml'));
            
            const requestBody = {
                input_path: this.file.key,
                output_file_name: options.output_file_name,
                output_html: options.output_html
            };
            
            // Add output_path only if it's provided (when saving to library)
            if (options.output_path !== undefined) {
                requestBody.output_path = options.output_path;
            }
            
            this.$mediaHttp.post('/v3/dms/media/pdf/pdf2html', requestBody, {
                responseType: options.output_html ? 'blob' : 'json'
            }).then(resp => {
                if (options.output_html) {
                    // Download the HTML file
                    const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'text/html' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', options.output_file_name);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    
                    this.$bvToast.toast(this.$t('htmlDownloadedSuccessfully'), {
                        title: this.$t('success'),
                        variant: 'success'
                    });
                } else {
                    // File was saved to library
                    this.$bvToast.toast(this.$t('conversionComplete'), {
                        title: this.$t('success'),
                        variant: 'success'
                    });
                    
                    // Emit event to parent to refresh the file list
                    this.$emit('fileConverted', resp.data);
                }
            }).catch(error => {
                console.error('PDF conversion error:', error);
                const message = error.response && error.response.data && error.response.data.message 
                    ? error.response.data.message 
                    : this.$t('conversionFailed');
                    
                this.$bvToast.toast(message, {
                    title: this.$t('error'),
                    variant: 'danger'
                });
            }).finally(() => {
                popup.hide();
            });
        },

        handleTxtToPdfConvert(options) {
            const popup = this.$loadingPopup(this.$t('convertingTxtToPdf'));

            const requestBody = {
                input_path: this.file.key,
                output_file_name: options.output_file_name,
                output_pdf: options.output_pdf
            };

            if (options.output_path !== undefined) {
                requestBody.output_path = options.output_path;
            }

            this.$mediaHttp.post('/v3/dms/media/pdf/txt2pdf', requestBody, {
                responseType: options.output_pdf ? 'blob' : 'json'
            }).then(resp => {
                if (options.output_pdf) {
                    const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', options.output_file_name);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    this.$bvToast.toast(this.$t('pdfDownloadedSuccessfully'), {
                        title: this.$t('success'),
                        variant: 'success'
                    });
                } else {
                    this.$bvToast.toast(this.$t('conversionComplete'), {
                        title: this.$t('success'),
                        variant: 'success'
                    });

                    this.$emit('fileConverted', resp.data);
                }
            }).catch(error => {
                console.error('TXT to PDF conversion error:', error);
                const message = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : this.$t('conversionFailed');

                this.$bvToast.toast(message, {
                    title: this.$t('error'),
                    variant: 'danger'
                });
            }).finally(() => {
                popup.hide();
            });
        },

        handleExtractText(options) {
            const popup = this.$loadingPopup(this.$t('extractingText'));

            const requestBody = {
                input_path: this.file.key,
                output_file_name: options.output_file_name,
                output_text: options.output_text
            };

            if (options.output_path !== undefined) {
                requestBody.output_path = options.output_path;
            }

            this.$mediaHttp.post('/v3/dms/media/extract-text', requestBody, {
                responseType: options.output_text ? 'blob' : 'json'
            }).then(resp => {
                if (options.output_text) {
                    const url = window.URL.createObjectURL(new Blob([resp.data], { type: 'text/plain' }));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', options.output_file_name);
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);

                    this.$bvToast.toast(this.$t('txtDownloadedSuccessfully'), {
                        title: this.$t('success'),
                        variant: 'success'
                    });
                } else {
                    this.$bvToast.toast(this.$t('extractionComplete'), {
                        title: this.$t('success'),
                        variant: 'success'
                    });

                    this.$emit('fileConverted', resp.data);
                }
            }).catch(error => {
                console.error('Text extraction error:', error);
                const message = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : this.$t('extractionFailed');

                this.$bvToast.toast(message, {
                    title: this.$t('error'),
                    variant: 'danger'
                });
            }).finally(() => {
                popup.hide();
            });
        },

        downloadFile() {
            this.$mediaHttp.get(this.file.local_url, { responseType: 'blob' }).then(resp => {
                const url = window.URL.createObjectURL(new Blob([resp.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', this.file.name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }).catch(err => {
                this.$bvToast.toast(this.$t('failedToDownloadFile'), {
                    title: this.$t('error'),
                    variant: 'danger'
                });
                console.error(err);
            });
        },

        copyUrlToClipboard() {
            const url = this.isPrivate ? this.file.local_url : this.file.public_url;
            
            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(url).then(() => {
                    this.$bvToast.toast(this.$t('urlCopiedToClipboard'), {
                        title: this.$t('success'),
                        variant: 'success'
                    });
                }).catch(() => {
                    this.fallbackCopyToClipboard(url);
                });
            } else {
                this.fallbackCopyToClipboard(url);
            }
        },

        fallbackCopyToClipboard(text) {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            
            try {
                document.execCommand('copy');
                this.$bvToast.toast(this.$t('urlCopiedToClipboard'), {
                    title: this.$t('success'),
                    variant: 'success'
                });
            } catch (err) {
                this.$bvToast.toast(this.$t('failedToCopyUrl'), {
                    title: this.$t('error'),
                    variant: 'danger'
                });
            }
            
            document.body.removeChild(textArea);
        },

        deleteFile() {
            this.$mainDialog.msgBoxConfirm(this.$t('areYouSureYouWantToDeleteThisFile')).then(resp => {
                if (resp) {
                    this.$emit('deleteFile', this.file);
                }
            });
        },

        showMoveModal() {
            // Extract current directory path from file key (remove filename)
            const currentPath = this.file.key.substring(0, this.file.key.lastIndexOf('/'));
            this.moveModal.newPath = currentPath || '/';
            this.moveModal.show = true;
        },

        handleMoveFile(event) {
            event.preventDefault();
            
            const popup = this.$loadingPopup(this.$t('movingFile'));
            
            // Construct the new full path with filename
            let newPath = this.moveModal.newPath;
            
            // Ensure new path starts with /
            if (!newPath.startsWith('/')) {
                newPath = '/' + newPath;
            }
            
            // Remove trailing slash if present
            if (newPath.endsWith('/')) {
                newPath = newPath.slice(0, -1);
            }
            
            const newFullPath = newPath + '/' + this.file.name;
            
            this.$mediaHttp.post('/v3/dms/media/move', {
                old_path: this.file.key,
                new_path: newFullPath
            }).then(resp => {
                this.$bvToast.toast(this.$t('fileMovedSuccessfully'), {
                    title: this.$t('success'),
                    variant: 'success'
                });
                
                this.moveModal.show = false;
                
                // Emit event to parent to remove this file from current view and refresh
                this.$emit('fileMoved', { 
                    oldPath: this.file.key, 
                    newPath: newFullPath,
                    file: this.file 
                });
            }).catch(error => {
                console.error('Move file error:', error);
                const message = error.response && error.response.data && error.response.data.message 
                    ? error.response.data.message 
                    : this.$t('moveFileFailed');
                    
                this.$bvToast.toast(message, {
                    title: this.$t('error'),
                    variant: 'danger'
                });
            }).finally(() => {
                popup.hide();
            });
        }
    }
}
</script>
